export default __webpack_public_path__ + "5c525e37b3195218bd5e322209ae8f98.png";